import { NewsletterModalProvider } from 'components/_global/layout/newsletter-modal';
import { NotificationsProvider } from 'components/_global/layout/notifications';
import type { ReactNode } from 'react';

const LayoutProviders = ({ children }: { children: ReactNode }) => (
  <NewsletterModalProvider>
    <NotificationsProvider>{children}</NotificationsProvider>
  </NewsletterModalProvider>
);

export default LayoutProviders;
